import { FC, useCallback, useLayoutEffect, useRef, useState } from 'react';

import { Tooltip } from 'antd';

import styles from './TruncatedText.module.scss';

type Props = {
	text: string;
};

export const TruncatedText: FC<Props> = ({ text }) => {
	const textRef = useRef<HTMLSpanElement>(null);
	const [isTruncated, setIsTruncated] = useState(false);
	const checkTruncation = useCallback(() => {
		const element = textRef.current;
		if (element) {
			setIsTruncated(element.scrollWidth > element.clientWidth);
		}
	}, []);

	useLayoutEffect(() => {
		checkTruncation();
	}, [checkTruncation]);

	return (
		<Tooltip
			title={isTruncated ? text : null}
			styles={{ root: { maxWidth: 'none' }, container: { whiteSpace: 'nowrap' } }}
		>
			<span ref={textRef} className={styles.text}>
				{text}
			</span>
		</Tooltip>
	);
};
